import { render, staticRenderFns } from "./AddCommentBar.vue?vue&type=template&id=4dc4c068&scoped=true&"
import script from "./AddCommentBar.vue?vue&type=script&lang=js&"
export * from "./AddCommentBar.vue?vue&type=script&lang=js&"
import style0 from "./AddCommentBar.vue?vue&type=style&index=0&id=4dc4c068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc4c068",
  null
  
)

export default component.exports